module.exports = __webpack_public_path__ + "img/szjc2.83698c94.png";